<template>
  <div class="document">
    <div class="header">
      <img src="progress.jpg" alt="Progress Logo" class="logo">
      <div class="signatory">
        «{{$t('Təsdiq_edirəm')}}»
        <br>
        {{$t('DSKŞ_nin_Sədrin_müşaviri')}}
        <br>
        {{ item.signer }}
        Əzizov Təbriz
        <br>
        {{ item.todayDateStr }}
      </div>
    </div>

    <div class="claim-number">
      {{$t('SIĞORTA_ÖDƏNİŞİ_İLƏ_BAĞLI_AKT')}} #: {{ item.dispClaimNumber }}
    </div>

    <section>
      <div class="section-heading">{{$t('Sığorta_müqaviləsinə_aid_ümumi_məlumatlar')}}</div>
      <div class="details">
        <div class="single-line">
          <div><span class="bold-title">{{$t('Sığorta_müqaviləsi')}}:</span> <span class="value">{{ item.insuranceContract }}</span></div>
          <div><span class="bold-title">{{$t('Sığorta_şəhadətnaməsi')}} №:</span> <span class="value">{{ item.policyNumber }}</span></div>
          <div><span class="bold-title">{{$t('Sığortan_növü')}}:</span> <span class="value">{{ item.insuranceTypeName }}</span></div>
          <div><span class="bold-title">{{$t('Filial')}}:</span> <span class="value">{{ item.branchName }}</span></div>
          <div><span class="bold-title">{{$t('Sığortalı')}}:</span> <span class="value">{{ item.insuredName }}</span></div>
          <div><span class="bold-title">{{$t('Sığorta_predmeti')}}:</span> <span class="value">{{ item.insuredDisplayName }}</span></div>
          <div><span class="bold-title">{{$t('Oturacaq_sayı')}}:</span> <span class="value">{{ item.numberOfSeats }}</span></div>
          <div><span class="bold-title">{{$t('Sığortanın_başlama_və_bitmə_tarixi')}}:</span> <span class="value">{{
            item.startDateStr + '&nbsp;&nbsp;-&nbsp;&nbsp;' + item.endDateStr }}</span></div>
          <div><span class="bold-title">{{$t('Sığorta_məbləği')}}:</span> <span class="value">{{ item.insuranceSum }}</span></div>
        </div>
      </div>
    </section>

    <section>
      <div class="section-heading">{{$t('Sığorta_hadisəsinə_dair_məlumatlar')}}</div>
      <div class="single-line">
        <div><span class="bold-title">{{$t('Hadisənin_baş_verdigi_tarix')}}:</span> <span class="value">{{ item.accidentDateStr }}</span></div>
        <div><span class="bold-title">{{$t('Məlumat_vermə_tarixi')}}:</span> <span class="value">{{ item.callDateStr }}</span></div>
        <div><span class="bold-title">{{$t('Sığorta_hadisəsinin_baş_verdigi_ərazi')}}:</span> <span class="value">{{ item.place }}</span></div>
        <div><span class="bold-title">{{$t('Hadisədə_zərərvuran_şəxs')}}:</span> <span class="value">{{ item.injuredName }}</span></div>
        <div><span class="bold-title">{{$t('Hadisədə_zərər_çəkənlərin_sayı')}}:</span> <span class="value">{{ item.vehicleCount }}</span></div>
        <div><span class="bold-title">{{$t('Zərərçəkən_avtomobilin_sürücüsü')}}:</span> <span class="value">{{ item.victimName }}</span></div>
        <div><span class="bold-title">{{$t('Zərərçəkən_avtomobilin_sürücüsünün_əlaqə_nömrəsi')}}:</span> <span class="value">{{ item.victimPhone }}</span></div>
        <div><span class="bold-title">{{$t('Zərər_vurulmuş_predmetə_dair_məlumat')}}:</span> <span class="value">{{ item.victimDisplayName }}</span></div>
        <div>
          <span class="bold-title">{{$t('Sığorta_hadisəsinin_növü')}}:</span>
          <span class="value">
            {{ item.damageCategoryName }}
            <span v-if="item.damageCategoryName === 'Xəsarət'">
              - {{ item.medDamageTypeName }}
            </span>
          </span>
        </div>
        <div><span class="bold-title">{{$t('Subroqasiya_tələbinin_mövcudluğuna_dair_məlumat')}}:</span> <span class="value">{{ item.subragationStatusName }}</span></div>
      </div>
    </section>

    <section>
      <div class="section-heading">{{$t('Dəymiş_zərər_barədə_məlumat')}}</div>
      <div class="single-line">
        <div><span class="bold-title">{{$t('Zərəri_müəyyən_edən_müəssisə')}}:</span> <span class="value">{{ item.basisPrice }}</span></div>
        <div><span class="bold-title">{{$t('Zərərin_müəyyən_edildiyi_tarix')}}:</span> <span class="value">{{ item.damageDateStr }}</span></div>
        <div><span class="bold-title">{{$t('Ümumi_zərər_məbləği')}}:</span> <span class="value">{{ item.damageSumLetter }}</span></div>
        <div><span class="bold-title">{{$t('Zərərçəkənin_zərərdə_payı')}}:</span> <span class="value">{{ item.damagePercentage }}</span></div>
      </div>
    </section>

    <section>
      <div class="section-heading">{{$t('Sığorta_ödənişi')}}</div>
      <div class="single-line">
        <div><span class="bold-title">{{$t('Hesablanmış_sığorta_ödənişi')}}:</span> <span class="value">{{ item.paymentSumLetter }}</span></div>
        <div><span class="bold-title">{{$t('Sığorta_ödənişini_alan')}}:</span> <span class="value">{{ item.paymentReceivedPerson }}</span></div>
        <div><span class="bold-title">{{$t('Telefon_nömrəsi')}}:</span> <span class="value">{{ item.paymentReceivedPersonPhone }}</span></div>
      </div>
    </section>

    <section>
      <div class="section-heading">{{$t('Yekun_müddəalar')}}</div>
      <span class="value">{{$t('Sığorta_ödənişi_şərtləri')}}</span>
    </section>

    <section>
      <div class="section-heading">{{$t('Sığorta_aktının_tərtibatçısı_və_təsdiq_edənlər')}}</div>
      <div class="single-line">
        <div><span class="bold-title">{{$t('Departament_direktoru')}}:</span> <span class="value">{{$t('Osmanlı_Mahmud')}}</span></div>
        <div><span class="bold-title">{{$t('Sığorta_hadisələri_şöbəsinin_müdiri')}}:</span> <span class="value">{{$t('Nəbiyev_Fuad')}}</span></div>
        <div><span class="bold-title">{{$t('Mütəxəssis_icraçı')}}:</span> <span class="value">{{ item.clientServiceUserName }}</span></div>
        <div><span class="bold-title">{{$t('Sığorta_iddialarının_tənzimlənməsi_şöbəsinin_müdiri')}}:</span> <span class="value">{{$t('Əhmədzadə_Rüfət')}}</span></div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
  },
  data() {
    return {
      item: this.value,
    };
  },
  watch: {
    value() {
      this.item = this.value;
    },
  },
};
</script>

<style lang="scss" scoped>
.document {
  color: black;
  font-family: Arial, sans-serif;
  /* Tarzınıza göre bir font seçebilirsiniz */
}

.value {
  font-size: 18px;
}

.left-value {
  font-size: 18px;
  width: 280px !important;
}

.right-value {
  font-size: 18px;
  width: 280px !important;
}


.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}

.logo {
  width: 300px;
  /* Logonuzun boyutuna göre ayarlayabilirsiniz */
}

.signatory {
  text-align: right;
}

.claim-number {
  text-align: center;
  margin: 20px 0;
  font-size: 24px;
}

/* Varsayılan stil */
.section-heading {
  background-color: rgb(6, 87, 130) !important;
  color: white !important;
  padding: 1px;
  font-weight: bold;
  font-size: 20px;
  border-radius: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.show-on-print-only {
  display: none;
}

@media print {
  .hide-on-print {
    display: none;
  }

  .show-on-print-only {
    display: initial;
  }

  .page-break-before {
    page-break-before: always;
  }

  .print-border {
    border: 1px solid #01579B;
  }
}

@media print and (color) {
  * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}



.details {
  display: flex;
  justify-content: space-between;
}

.left-side div span,
.right-side div span {
  display: inline-block;
  width: 220px;
  /* Bu genişliği başlıklarınızın genişliğine göre ayarlayabilirsiniz */
}


.single-line span {
  display: inline-block;
}

.bold-title {
  font-weight: bold;
  font-size: 19px;
  width: 500px;
}
</style>
